import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";

import { LabelGrid, NavLine, StageCircle, StageLine, TopGrid } from "../../styles/ReferralRequestTimeline";
import fontWeight from "../../../../styles/mui/fontWeight";
import { colors } from "../../../../styles/colors";
import { TimelineInfo } from "../../../../constants/ReferralRequestor";
import { TimelineData } from "../../../../models/ReferralRequestor";

const ReferralRequestTimeline = () => {

    return (
        <>
            <Grid container sx={TopGrid}>
                {TimelineInfo.map((item: TimelineData) => (
                    <Box key={item.id} sx={{ display: "flex" }}>
                        <Grid>
                            <Box sx={StageCircle()}>{item.id}</Box>
                        </Grid>
                        <Grid sx={LabelGrid}>
                            <Typography
                                variant="h6"
                                fontWeight={item.id === 1 ? fontWeight.Weight[6] : fontWeight.Weight[3]}
                                color={colors.black[2]}
                            >
                                {item.label}
                            </Typography>
                        </Grid>
                        <Grid >
                            <Box sx={StageLine}>
                                {item.id === 2 ? "" : <Box sx={NavLine}></Box>}
                            </Box>
                        </Grid>
                    </Box>
                ))}


            </Grid>
        </>
    )
}

export default ReferralRequestTimeline;